<div class="schedule-navbar">
    <mat-form-field class="picker-date">
        <input [matDatepicker]="pickerDate" [formControl]="fcDate" (focus)="pickerDate.open()" matInput tabindex="-1" />
        <mat-datepicker #pickerDate></mat-datepicker>
    </mat-form-field>
    <div>
        <button (click)="prev()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-left"></mat-icon>
        </button>
    </div>
    <div class="content" (click)="pickerDate.open()">
        <p class="large">{{ date | date: 'd MMM' }}</p>
        <p class="small">{{ date | date: 'EEEE' }}</p>
    </div>
    <div>
        <button (click)="next()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-right"></mat-icon>
        </button>
    </div>
</div>
<div class="day-check-realisations-check first last">
    @if (show) {
        <div class="list">
            @for (user of users; track user; let even = $even) {
                <div class="list-item" [class.warn]="!even">
                    <div class="container">
                        <div class="content">
                            <div class="name-wrapper">
                                <div class="name">
                                    {{ user.name }}
                                </div>
                                <div class="caption">
                                    {{ userRealisationMap.get(user.id)?.projects | joinBy }}
                                </div>
                            </div>
                            <div class="prefix">
                                @if (!userRealisationMap.get(user.id)) {
                                    <button class="icon-button" mat-icon-button disabled>
                                        <i class="fa-light fa-user-slash" matTooltip="Medewerker niet ingepland"></i>
                                    </button>
                                    <button class="icon-button" mat-icon-button disabled>
                                        <i class="fa-light fa-user-slash" matTooltip="Medewerker niet ingepland"></i>
                                    </button>
                                } @else if (userRealisationMap.get(user.id)) {
                                    <button
                                        class="icon-button invalid"
                                        [class.invalid]="
                                            !userRealisationMap.get(user.id)?.allSubmitted &&
                                            userRealisationMap.get(user.id)?.adjustable
                                        "
                                        [class.valid]="userRealisationMap.get(user.id)?.allSubmitted"
                                        mat-icon-button
                                        disabled>
                                        @if (
                                            !userRealisationMap.get(user.id)?.allSubmitted &&
                                            userRealisationMap.get(user.id)?.adjustable &&
                                            !userRealisationMap.get(user.id)?.adjustable_time
                                        ) {
                                            <i
                                                class="fa-light fa-user-slash"
                                                matTooltip="Gebruiker heeft geen uren ingevoerd binnen 24 uur"></i>
                                        }
                                        @if (
                                            !userRealisationMap.get(user.id)?.allSubmitted &&
                                            userRealisationMap.get(user.id)?.adjustable &&
                                            userRealisationMap.get(user.id)?.adjustable_time
                                        ) {
                                            <i
                                                class="fa-light fa-user-clock"
                                                matTooltip="Wacht op invoer gebruiker"></i>
                                        }
                                        @if (
                                            userRealisationMap.get(user.id)?.allSubmitted ||
                                            !userRealisationMap.get(user.id)?.adjustable
                                        ) {
                                            <i
                                                class="fa-light fa-check-circle"
                                                [matTooltip]="
                                                    userRealisationMap.get(user.id)?.adjustable
                                                        ? 'Uren ingevoerd'
                                                        : 'Gebruiker registreert zelf geen uren'
                                                "></i>
                                        }
                                    </button>
                                    <button
                                        class="icon-button"
                                        [class.invalid]="
                                            !userRealisationMap.get(user.id)?.allApproved &&
                                            (!userRealisationMap.get(user.id)?.adjustable ||
                                                !userRealisationMap.get(user.id)?.adjustable_time)
                                        "
                                        [class.valid]="userRealisationMap.get(user.id)?.allApproved"
                                        mat-icon-button
                                        disabled>
                                        @if (userRealisationMap.get(user.id)?.allApproved) {
                                            <i class="fa-light fa-check-circle" matTooltip="Uren goedgekeurd"></i>
                                        }
                                        @if (!userRealisationMap.get(user.id)?.allApproved) {
                                            <i
                                                class="fa-light fa-user-clock"
                                                matTooltip="Uren wachten op goedkeuring"></i>
                                        }
                                    </button>
                                }
                            </div>
                            <div class="times">
                                <div class="time" [class.downlight]="userRealisationMap.get(user.id)?.worktime < 1">
                                    {{ userRealisationMap.get(user.id)?.worktime | minutes }}
                                    <small>werktijd</small>
                                </div>
                                <div class="time" [class.downlight]="userRealisationMap.get(user.id)?.sleep < 1">
                                    {{ userRealisationMap.get(user.id)?.sleep | minutes }}
                                    <small>slaap</small>
                                </div>
                                <div
                                    class="time"
                                    [class.downlight]="userRealisationMap.get(user.id)?.break < 1"
                                    [class.difference]="userRealisationMap.get(user.id)?.pause_adjusted">
                                    {{ userRealisationMap.get(user.id)?.break | minutes }}
                                    <small>pauze</small>
                                </div>
                                <div class="time" [class.downlight]="userRealisationMap.get(user.id)?.drivingtime < 1">
                                    {{ userRealisationMap.get(user.id)?.drivingtime | minutes }}
                                    <small>transporttijd</small>
                                </div>
                                <div class="time" [class.downlight]="userRealisationMap.get(user.id)?.traveltime < 1">
                                    {{ userRealisationMap.get(user.id)?.traveltime | minutes }}
                                    <small>reistijd</small>
                                </div>
                                <div class="time" [class.downlight]="userRealisationMap.get(user.id)?.leavetime < 1">
                                    {{ userRealisationMap.get(user.id)?.leavetime | minutes }}
                                    <small>verlof</small>
                                </div>
                                <div class="time" [class.downlight]="userRealisationMap.get(user.id)?.illnesstime < 1">
                                    {{ userRealisationMap.get(user.id)?.illnesstime | minutes }}
                                    <small>verzuim</small>
                                </div>
                            </div>
                            <div class="buttons">
                                <button
                                    class="planning-button"
                                    (click)="openHours(date, user)"
                                    mat-icon-button
                                    color="primary">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                                <div class="comment">
                                    @if (false) {
                                        <button class="planning-button" mat-icon-button color="primary">
                                            <i class="fas fa-history"></i>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
</div>

<div class="button-wrapper">
    <div class="container">
        <div class="buttons">
            <button
                class="planning-button"
                mat-raised-button
                color="accent"
                routerLink="/weekcontrole/{{ date | date: 'yyyy' }}/{{ date | date: 'w' }}">
                Weekcontrole
            </button>
            <div class="settings-menu">
                <app-settings-menu [date]="date"></app-settings-menu>
            </div>
            <button
                class="planning-button"
                mat-raised-button
                color="primary"
                routerLink="/check-hours/{{ date | date: 'yyyy-MM-dd' }}">
                Urencontrole
            </button>
        </div>
    </div>
</div>
